module.exports = __webpack_public_path__ + "img/pattern.378eaf0d.png";